import { ReactNode } from 'react';
import { SelectOption, SelectX6 } from './SelectX6';
import { EditCellBase } from './EditCellBase';

export function EditCellSelectMulti({
	children,
	value,
	options,
	saveValues,
	disabled,
	altColor,
}: {
	children: ReactNode;
	options: SelectOption[];
	value: string[];
	saveValues: (select: string[]) => Promise<void>;
	disabled?: boolean;
	altColor?: boolean;
}) {
	return (
		<EditCellBase
			altColor={altColor}
			value={value}
			saveValues={saveValues}
			disabled={disabled}
			renderEditor={({ value: valueRender, onChange: onChangeRender, saving }) => (
				<SelectX6
					multi={true}
					value={valueRender}
					onChange={onChangeRender}
					options={options}
					disabled={saving}
					disableClick={true}
				/>
			)}
		>
			{children}
		</EditCellBase>
	);
}
